// extracted by mini-css-extract-plugin
module.exports = {"overlay":"LoadingOverlay_overlay__1xsGg"};